<template>
  <div id="app">
    <!-- 页面整体容器，纵向分层 -->
    <div class="page-wrap">
      <!-- 顶部整行：A方块 | 中间T+H垂直区域 | G头像区 -->
      <div class="top-root-row">
        <!-- A 正方装饰块 -->
        <div class="block-a">
          <div class="a-inner"></div>
        </div>

        <!-- 中间垂直两栏 T导航 + H状态栏 -->
        <div class="top-middle-col">
          <div class="block-t">
            <div class="topt"></div>
            <div class="menu-list">
              <div class="menu-item" @click="$router.push('/wordbook')">
                生词本
              </div>
            </div>
            <div class="stat-bar">
              <div class="stat-item">
                <span class="label">今日阅读 </span>
                <span class="num">{{ todayMinute }} 分 {{ todayFinishCount }} 篇</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 右侧G头像昵称区域 -->
        <div class="block-g">
          <div class="avatar-box" @click="$router.push('/userinfo')">
            <img
              :src="avatarUrl || '/default_avatar.png'"
              class="avatar-img"
              @error="handleAvatarError"
            />
          </div>
          <div class="nickname-text">{{ userInfo.nickname || "nobody" }}</div>
        </div>
      </div>

      <!-- 中间主体区域：左侧E1竖边框 | 主内容 | 右侧E2竖边框 -->
      <div class="main-root-row">
        <div class="block-e1"></div>
        <div class="content-wrap">
          <router-view />
        </div>
        <div class="block-e2"></div>
      </div>

      <!-- 底部通栏F -->
      <div class="block-f">
        <!-- 左侧固定花纹段 -->
        <div class="f-left"></div>
        <!-- 中间自适应平铺段 -->
        <div class="f-center"></div>
        <!-- 右侧固定花纹段 -->
        <div class="f-right"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { fullPageRoutes } from "@/router";
import { readerFetch } from "@/utils/request";
import { API_BASE } from "@/config/env";

export default {
  name: "App",
  data() {
    return {
      userInfo: {
        avatar: "",
        nickname: ""
      },
      avatarUrl: "",
      todayMinute: 0,
      todayFinishCount: 0,
      currentReaderId: Number(localStorage.getItem("readerId")) || 0
    };
  },
  computed: {
    fullPageRoutes() {
      return fullPageRoutes;
    }
  },
  mounted() {
    this.loadUserInfo();
    this.fetchHomeStat();
  },
  watch: {
    $route() {
      this.loadUserInfo();
      this.fetchHomeStat();
    }
  },
  methods: {
    // 头像加载失败兜底默认图
    handleAvatarError() {
      this.avatarUrl = "/default_avatar.png";
    },
    async loadUserInfo() {
      const readerId = localStorage.getItem("readerId");
      if (!readerId || readerId === "") {
        this.userInfo = { avatar: "", nickname: "" };
        this.avatarUrl = "";
        return;
      }
      try {
        const res = await readerFetch(`/info?reader_id=${readerId}`);
        // 接口大写字段转小写赋值
        this.userInfo = {
          avatar: res.data.Avatar || "",
          nickname: res.data.Nickname || ""
        };
        if (this.userInfo.avatar) {
          this.avatarUrl = `${API_BASE}${this.userInfo.avatar}`;
        } else {
          this.avatarUrl = "";
        }
      } catch (err) {
        console.error("用户信息接口报错：", err);
        this.userInfo = { avatar: "", nickname: "" };
        this.avatarUrl = "";
      }
    },
    // 获取首页今日统计（使用当前登录用户真实ID）
    async fetchHomeStat() {
      if (!this.currentReaderId) return
      try {
        const res = await readerFetch(`/read/homeStat?readerId=${this.currentReaderId}`)
        if(res.code === 200){
          this.todayMinute = res.todayMinute || 0
          this.todayFinishCount = res.todayFinishCount || 0
        }
      } catch (e) {
        this.todayMinute = 0
        this.todayFinishCount = 0
      }
    },
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
#app {
  width: 100vw;
  height: 100dvh;
  overflow: hidden;
  position: relative;
  min-height: 620px;
  background-image: url("@/assets/bg1.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-color: #f7f2fc;
  padding-bottom: env(safe-area-inset-bottom, 20px);
  box-sizing: border-box;
}

.page-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 620px;
  background: transparent !important; /* 关键：清空白色底色，透出背景 */
}
/* 下面你所有A/T/H/E/F、头像样式全部保留，这里省略，不用改 */
.top-root-row {
  display: flex;
  align-items: stretch;
  height: 107px;
  width: 100%;
  flex-shrink: 0;
  gap: 0;
}
.block-a {
  width: 107px;
  /* 取消垂直居中，改为顶部对齐，和T顶部齐平 */
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}
.a-inner {
  width: 100%;
  padding-top: 100%;
  background-image: url("@/assets/a.png");
  background-size: contain;
  background-position: top left;
  background-repeat: no-repeat;
}
.top-middle-col {
  flex: 1;
  display: flex;
  align-items: stretch;
}
.block-t {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-image: url("@/assets/t.png");
  background-size: auto 100%;
  background-position: left center;
  background-repeat: repeat-x;
}
.topt{
  height: 36px;
}
.menu-list {
  margin-left: 45px;
  height: 36px;
  gap:10px;
  display: flex;
}
.menu-item {
  background-image: url("@/assets/m.png");
  background-size:contain;
  font-size: 18px;
  color: #fcffac;
  padding: 4px 10px;
  white-space: nowrap;
}
.stat-bar {
  margin-left: 30px;
  height: 20px;
  width: 138px;
  background-color:#ffeeaa38;
  display: flex;
  align-items: top center;
  font-size: 12px;
  color: #68d51b;
}
.stat-item {
  padding-left: 8px;
  padding-top: 2px;
  white-space: nowrap;
}

.block-g {
  width: 110px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items:flex-end;
  justify-content: top;
  background-image: url("@/assets/g.png");
  background-size: cover;
  background-position: center;
}
.avatar-box {
  margin: 5px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid #f3f3f3;
}
.avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.nickname-text {
  margin-right: 10px;
  font-size: 15px;
  color: #ffe6ef;
  margin-top: 7px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 95px; /* 控制最大显示宽度，按需改 */
}
.main-root-row {
  flex: 1;
  display: flex;
  width: 100%;
  min-height: 400px;
}
.block-e1, .block-e2 {
  width: 25px;
  flex-shrink: 0;
  height: 100%;
  background-repeat: repeat-y;
  background-position: top left;
  background-size: 100% auto;
}
.block-e1 {
  background-image: url("@/assets/e1.png");
}
.block-e2 {
  background-image: url("@/assets/e2.png");
}
.content-wrap {
  flex: 1;
  overflow-y: auto;
}
/* 底部F容器，横向弹性布局 */
.block-f {
  width: 100%;
  height: 53px;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  /* background-color: aqua; */
}
/* 左段固定宽度，放左侧边角花纹 */
.f-left {
  width: 65px; /* 自定义固定尺寸 */
  height: 100%;
  flex-shrink: 0;
  background-image: url("@/assets/f1.png");
  background-repeat: no-repeat;
  background-size: auto 100%;
  background-position: left center;
}
/* 中间自适应填充，循环平铺花纹 */
.f-center {
  flex: 1; /* 自动占满剩余全部宽度 */
  background-image: url("@/assets/f.png");
  background-repeat: repeat-x;
  background-size: auto 100%;
  background-position: left center;
}
/* 右段固定宽度，放右侧边角花纹 */
.f-right {
  width: 65px; /* 和左侧宽度统一，可单独调整 */
  height: 100%;
  flex-shrink: 0;
  background-image: url("@/assets/f2.png");
  background-repeat: no-repeat;
  background-size: auto 100%;
  background-position: right center;
}

</style>